// src/components/Hero/Hero.jsx
import React, { useState } from "react";
import { motion } from "framer-motion";
import { useLocalContext } from "../../context/LocalContext";
import "./Hero.css";

const Hero = ({ onSubmitLead }) => {
  const { webinfo = {} } = useLocalContext();
  const brandName = webinfo?.name || "Your Brand";

  const [form, setForm] = useState({ name: "", phone: "", service: "" });
  const [status, setStatus] = useState({ loading: false, ok: "", err: "" });

  const onChange = (e) => {
    setStatus({ loading: false, ok: "", err: "" });
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      return setStatus({ loading: false, ok: "", err: "Please fill all required fields." });
    }

    try {
      setStatus({ loading: true, ok: "", err: "" });
      await onSubmitLead?.({ ...form, source: "hero_about_theme" });
      setStatus({ loading: false, ok: "We'll contact you shortly.", err: "" });
      setForm({ name: "", phone: "", service: "" });
    } catch {
      setStatus({ loading: false, ok: "", err: "Submission failed. Try again." });
    }
  };

  return (
    <section className="heroAboutTheme">
      <div className="heroAboutTheme-wrap">
        <motion.div
          className="heroAboutTheme-left"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <span className="hero-tag">Your growth partner</span>

          <h1>
            Websites that <br />
            <span>convert and scale</span>
          </h1>

          <p>
            {brandName} builds fast, clear digital experiences that win trust and drive leads—from strategy and design to development and ongoing support.
          </p>

          <ul>
            <li>Conversion-focused design</li>
            <li>SEO and performance built in</li>
            <li>Ongoing support when you need it</li>
          </ul>

          <div className="heroStats">
            <div><strong>30+</strong><span>Projects</span></div>
            <div><strong>4.8★</strong><span>Client rating</span></div>
            <div><strong>&lt;24h</strong><span>Response</span></div>
          </div>
        </motion.div>

        <motion.div
          className="heroAboutTheme-card"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <h2>Free consultation</h2>
          <p>Share your goals and we'll recommend the right next step—no obligation.</p>

          <form onSubmit={handleSubmit}>
            <input
              name="name"
              value={form.name}
              onChange={onChange}
              placeholder="Your name"
            />

            <input
              name="phone"
              value={form.phone}
              onChange={onChange}
              placeholder="Phone number"
            />

            <select
              name="service"
              value={form.service}
              onChange={onChange}
            >
              <option value="">Service you're interested in</option>
              <option>Website Development</option>
              <option>SEO & Growth</option>
              <option>Performance Marketing</option>
              <option>Automation</option>
            </select>

            {status.err && <div className="heroMsg err">{status.err}</div>}
            {status.ok && <div className="heroMsg ok">{status.ok}</div>}

            <button disabled={status.loading}>
              {status.loading ? "Submitting…" : "Get started"}
            </button>
          </form>

          <small>No contracts · Free audit · No pressure</small>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
